<template>
  <a-layout class="container">
    <!-- 左侧区域 -->
    <hina-base-slider :currentMenuKey='curMenuKey' :currentOpenKey='curOpenKey'/>
    <!-- 主体区域 -->
    <a-layout>
      <!-- 头部 -->
      <hina-user-info :user='objUserInfo'/>

      <a-layout-content>
        <!-- 位置 -->
        <hina-bread-crumb :link='arrBreadLink'/>

        <!-- 主体 -->
        <div class="wrapper" >

          <div>
            <a-spin :spinning="spinning">
              <div class="spin-content">
                <div class="clearfix">
                  <a-upload
                      :file-list="fileList"
                      :remove="handleRemove"
                      :before-upload="beforeUpload"
                      accept=".xls,.xlsx"
                  >
                    <a-button id="upload">
                      <a-icon type="upload"/>
                      批量导入职员
                    </a-button>
                  </a-upload>
                  <a-button
                      target="_top"
                      type="primary"
                      :disabled="fileList.length === 0"
                      :loading="uploading"
                      style="margin-top: 16px"
                      @click="handleUpload"
                  >
                    {{ uploading ? '上传' : '开始上传' }}
                  </a-button>
                </div>
              </div>
          <div>
            <a-back-top/>
            <strong style="color: rgba(64, 64, 64, 0.6)"> </strong>
          </div>
          <div class="wrap" v-if="success">
            <div class="hd">失败列表</div>
            <div class="trans-table">
              <a-table :columns="arrTabCol" :data-source="arrTabRow" :row-key="record => record.id" :pagination='false'>
              </a-table>
            </div>
          </div>
          <a-result v-if="resultStatus=='success'"
                    title="导入成功"
                    sub-title=""
                    status="success" >
            <template #extra>
              <a-button key="console" @click="handleToStaff" type="primary">
                前往职员管理
              </a-button>
              <a-button @click="handleContinue" key="buy">
                继续导入职员
              </a-button>
            </template>
          </a-result>
          <a-result v-if="resultStatus=='warning'" status="warning" title="您导入的职员中,可能有一些并没有导入成功!">
            <template #extra>
              <a-button key="console" @click="handleDetail" type="primary">
                查看详情
              </a-button>
            </template>
          </a-result>
            </a-spin>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import HinaBaseSlider from 'components/HinaBaseSlider/HinaBaseSlider'
import HinaUserInfo from 'components/HinaUserInfo/HinaUserInfo'
import HinaBreadCrumb from 'components/HinaBreadCrumb/HinaBreadCrumb'
import {upload} from "@/network/db";


export default {
  name: 'BatchImport',
  components: {
    HinaBaseSlider,
    HinaUserInfo,
    HinaBreadCrumb,
  },
  data() {


    return {
      objUserInfo: {},
      curMenuKey: ['import'],
      curOpenKey: ['sub1'],

      arrBreadLink: [],

      fileList: [],
      uploading: false,
      spinning: false,

      arrTabCol: [],
      arrTabRow: [],
      success: false,
      resultStatus: '',
    }
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    handleUpload() {
      const {fileList} = this;
      const formData = new FormData();
      // fileList.forEach(file => {
      //   formData.append('files[]', file);
      // });
      if (fileList.length > 1) {
        this.$warning({
          title: '提示',
          content: '暂不支持多文件上传',
        });
        return;
      }
      this.spinning = !this.spinning;
      formData.append('file', fileList[0]);
      this.uploading = true;

      // 上传文件
      this.$upload('enterpriseUser/import', formData).then(res => {
        console.log(res.data.result)
        let list = res.data.result;
        this.arrTabRow = [];
        list.forEach(item => {
          this.arrTabRow.push({
            phone: item.phone,
            reason: item.reason,
          })
        })
        this.uploading = false;
        this.fileList = [];
        this.spinning = !this.spinning;
        this.success = false;
        this.resultStatus= list.length > 0?'warning':'success';
        this.$message.success('上传成功');
      }).catch(() => {
        this.uploading = false;
        this.spinning = !this.spinning;
        this.$message.error('上传失败');
      });
    },

    //查看详情
    handleDetail() {
      this.resultStatus = '';
      this.success = !this.success;
    },

    //前往职员管理
    handleToStaff() {
      this.$router.push('/staff');
    },

    //继续导入职员
    handleContinue() {
      this.fileList = [];
      //获取上传按钮
      let btn = document.getElementById('upload');
      btn.click();
      this.resultStatus = '';
    }
  },
  mounted: function () {
    this.objUserInfo = this.$store.state.userInfo || JSON.parse(localStorage.getItem("userInfo"))
    this.arrBreadLink.push({name: '批量导入', link: '/import'})

    this.arrTabCol = [
      {
        title: '手机号',
        dataIndex: 'phone',
        key: 'phone',
        width: '200px'
      },
      {
        title: '失败原因',
        dataIndex: 'reason',
        key: 'reason',
      },
    ]
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  .wrap {
    margin: 20px 0 0;
    padding: 0 24px;
    background: #FFF;
    min-height: 240px;

    .hd {
      height: 72px;
      line-height: 72px;
      color: #333;
      font-weight: 600;
      font-size: 18px;
      position: relative;
      margin-bottom: 30px;

      &::after {
        position: absolute;
        content: '';
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 0;
        right: 0;
        bottom: 0;
      }

      .filter {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .query {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .query-item {
            padding: 0 0 0 5px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .trans-table {
      padding: 0 0 5px;
    }
  }

  .wrap:first-of-type {
    margin: 0;
  }
}

/* From uiverse.io */
//button {
//  padding: 1.3em 3em;
//  font-size: 12px;
//  text-transform: uppercase;
//  letter-spacing: 2.5px;
//  font-weight: 500;
//  color: #000;
//  background-color: #fff;
//  border: none;
//  border-radius: 45px;
//  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
//  transition: all 0.3s ease 0s;
//  cursor: pointer;
//  outline: none;
//}

button[target]:hover {
  background-color: #23c483;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  color: #fff;
  transform: translateY(-7px);
}

button[target]:active {
  transform: translateY(-1px);
}

</style>